import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";
import { formatDate, initials } from "@/lib/utils-app";

export default function Admin() {
  const [users, setUsers] = useState([]);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const [u, s] = await Promise.all([api.get("/admin/users"), api.get("/stats")]);
        setUsers(u.data); setStats(s.data);
      } finally { setLoading(false); }
    })();
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 animate-fade-in-up">
      <div className="text-xs uppercase tracking-[0.2em] text-zinc-500 font-semibold">Handläggarpanel</div>
      <h1 className="mt-2 text-3xl sm:text-4xl font-semibold tracking-tight text-zinc-900" style={{ fontFamily: "Outfit" }}>
        Adminpanel
      </h1>

      {loading ? (
        <div className="flex justify-center py-20 text-zinc-500"><Loader2 className="w-5 h-5 animate-spin" /></div>
      ) : (
        <>
          <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-4">
            <div className="bg-white border border-zinc-200 rounded-sm p-5">
              <div className="text-xs uppercase tracking-wider text-zinc-500 font-semibold">Användare</div>
              <div className="mt-2 text-3xl font-semibold" style={{ fontFamily: "Outfit" }}>{users.length}</div>
            </div>
            <div className="bg-white border border-zinc-200 rounded-sm p-5">
              <div className="text-xs uppercase tracking-wider text-zinc-500 font-semibold">Totalt ärenden</div>
              <div className="mt-2 text-3xl font-semibold" style={{ fontFamily: "Outfit" }}>{stats?.total ?? 0}</div>
            </div>
            <div className="bg-white border border-zinc-200 rounded-sm p-5">
              <div className="text-xs uppercase tracking-wider text-amber-700 font-semibold">Komplettering</div>
              <div className="mt-2 text-3xl font-semibold text-amber-700" style={{ fontFamily: "Outfit" }}>{stats?.by_status?.komplettering ?? 0}</div>
            </div>
            <div className="bg-white border border-zinc-200 rounded-sm p-5">
              <div className="text-xs uppercase tracking-wider text-emerald-700 font-semibold">Beslut</div>
              <div className="mt-2 text-3xl font-semibold text-emerald-700" style={{ fontFamily: "Outfit" }}>{stats?.by_status?.beslut ?? 0}</div>
            </div>
          </div>

          <div className="mt-10 bg-white border border-zinc-200 rounded-sm overflow-hidden">
            <div className="px-6 py-4 border-b border-zinc-200">
              <h3 className="text-lg font-medium" style={{ fontFamily: "Outfit" }}>Användare</h3>
            </div>
            <table className="w-full text-sm">
              <thead className="bg-zinc-50 text-xs uppercase tracking-wider text-zinc-500">
                <tr>
                  <th className="text-left px-6 py-3 font-semibold">Användare</th>
                  <th className="text-left px-6 py-3 font-semibold">E-post</th>
                  <th className="text-left px-6 py-3 font-semibold">Roll</th>
                  <th className="text-left px-6 py-3 font-semibold">Telefon</th>
                  <th className="text-left px-6 py-3 font-semibold">Skapad</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-zinc-100">
                {users.map((u) => (
                  <tr key={u.user_id} data-testid={`admin-user-${u.user_id}`}>
                    <td className="px-6 py-4">
                      <div className="flex items-center gap-3">
                        <div className="w-8 h-8 rounded-full bg-zinc-100 flex items-center justify-center text-xs font-semibold">
                          {initials(u.name)}
                        </div>
                        <span className="font-medium text-zinc-900">{u.name}</span>
                      </div>
                    </td>
                    <td className="px-6 py-4 text-zinc-700">{u.email}</td>
                    <td className="px-6 py-4">
                      <span className={`px-2 py-0.5 text-xs font-semibold uppercase tracking-wider border rounded-sm ${
                        u.role === "admin" ? "border-emerald-200 bg-emerald-50 text-emerald-700" : "border-blue-200 bg-blue-50 text-blue-700"
                      }`}>
                        {u.role === "admin" ? "Handläggare" : "Användare"}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-zinc-600">{u.phone || "–"}</td>
                    <td className="px-6 py-4 text-zinc-500">{formatDate(u.created_at)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}
